import { LoadableList } from "external/immutability-helper"
import { Context } from "./context"

export type SubscriptionStatus = 'active' | 'canceled' | 'past_due' | 'pending'

export type PackageCourse = {
    id: string
    name: string
}

export type PackageUser = {
    id: string
    name: string
    first_name: string
    last_name: string
    email: string
}

export type HomeschoolerUser = {
    id: string
    person: {
        firstName: string
        lastName: string
        email: string
        phone: string
    }
}

export type Package = {
    id: string
    index: number,
    offerName: string
    plan_alias: string
    purchaseDate: Date
    purchase: string
    paymentMode: 'subscription' | 'payment'
    subscription: string
    subscriptionEnds: Date | null
    subscriptionStatus: SubscriptionStatus
    assigned: boolean
    student: null | PackageUser
    tutor: null | PackageUser
}

export type PackageItem = {
    loading: boolean,
    courses: {
        basic: Array<PackageCourse>
        elective: Array<PackageCourse>
    }
    data: null | Package
}

export type SelectUser = {
    open: boolean,
    search: string,
    loading: boolean,
    refresh: number,
    purchase: Package | null,
    users: PackageUser[],
    selectedUser: PackageUser | null
}

export const clearedSelectUser: SelectUser = {open: false, search: '', loading: false, refresh: 0, users: [], purchase: null, selectedUser: null}
export const clearedChangedPackageAlias = {open: false, id: null as unknown as string, plan_alias: '', index: -1}
export const clearedUserState = {open: false, purchase: {}, profile_id: '', person_id: '', first_name: '', last_name: '', email: '', phone: ''}

export type SavingMap = {
    [Property: string] : {
        [SavingProperty: string]: boolean
    }
}

export type PackageState = {
    packageRefreshes: number,
    packages: LoadableList<Package>
    packageItem: PackageItem
    modals: {
        changePackageAlias: typeof clearedChangedPackageAlias,
        selectStudent: SelectUser,
        selectTutor: SelectUser,
        addTutor: typeof clearedUserState,
        addStudent: typeof clearedUserState,
        studentAssignmentWarning: {open: boolean}
    },
    saving: SavingMap
}

export type PackageContext = Context<PackageState>